import { NavLink, useNavigate } from "react-router-dom";
import {
  ArrowUpRight,
  BarChart3,
  CalendarClock,
  CircleDollarSign,
  LayoutDashboard,
  LogOut,
  Receipt,
  Repeat,
  Target,
  UsersRound,
  UserPlus,
  WalletCards,
  X,
} from "lucide-react";
import { useAuth } from "../context/AuthContext";
import CompanySwitcher from "./CompanySwitcher";

const nav = [
  { to: "/", label: "Genel Bakış", icon: LayoutDashboard, end: true, testid: "nav-dashboard" },
  { to: "/transactions", label: "Gelir · Gider", icon: ArrowUpRight, testid: "nav-transactions" },
  { to: "/accounts", label: "Banka Hesapları", icon: WalletCards, testid: "nav-accounts" },
  { to: "/contacts", label: "Cari Hesaplar", icon: UsersRound, testid: "nav-contacts" },
  { to: "/upcoming", label: "Ödemeler & Tahsilatlar", icon: CalendarClock, testid: "nav-upcoming" },
  { to: "/invoices", label: "Faturalar", icon: Receipt, testid: "nav-invoices" },
  { to: "/recurring", label: "Tekrarlayan İşlemler", icon: Repeat, testid: "nav-recurring" },
  { to: "/reports", label: "Raporlar", icon: BarChart3, testid: "nav-reports" },
];

const secondaryNav = [
  { to: "/budgets", label: "Bütçe & Kategori", icon: Target, testid: "nav-budgets" },
  { to: "/team", label: "Ekip Üyeleri", icon: UserPlus, testid: "nav-team" },
];

export default function Sidebar({ open, onClose }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  const initials = (user?.name || user?.email || "V")
    .split(" ")
    .map((s) => s[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <aside className={open ? "sidebar open" : "sidebar"} data-testid="sidebar">
      <div className="brand">
        <div className="brand-mark">
          <CircleDollarSign size={20} />
        </div>
        <span>verafin</span>
        <button className="mobile-close icon-btn" onClick={onClose} data-testid="close-mobile-menu">
          <X size={17} />
        </button>
      </div>

      <CompanySwitcher />

      <div className="nav-label">ANA MENÜ</div>
      <nav>
        {nav.map(({ to, label, icon: Icon, end, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}
            onClick={onClose}
            data-testid={testid}
          >
            <Icon size={17} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="nav-label secondary-label">YÖNETİM</div>
      <nav>
        {secondaryNav.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}
            onClick={onClose}
            data-testid={testid}
          >
            <Icon size={17} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-bottom">
        <div className="plan">
          <div>
            <span>VeraFin Pro</span>
            <small>Deneme sürüm</small>
          </div>
          <ArrowUpRight size={15} />
        </div>
        <div className="user-row" data-testid="user-menu">
          <div className="user-avatar">{initials}</div>
          <div>
            <strong>{user?.name || "Kullanıcı"}</strong>
            <small>{user?.email}</small>
          </div>
          <button className="icon-btn logout-btn" onClick={handleLogout} data-testid="logout-button" aria-label="Çıkış">
            <LogOut size={15} />
          </button>
        </div>
      </div>
    </aside>
  );
}
